export default __webpack_public_path__ + "static/media/patient-based-icon.a6c9dfd4.png";